<eco-fab-speed-dial [(open)]="open" [direction]="direction" [animationMode]="animationMode">
  <eco-fab-speed-dial-trigger [spin]="spin">
    <button [matTooltip]="'Get Help'" matTooltipPosition="left" matTooltipClass="text-center" mat-fab class="trigger">
      <mat-icon>
        <i class="icon far fa-question-circle"></i>
      </mat-icon>
    </button>
  </eco-fab-speed-dial-trigger>

  <eco-fab-speed-dial-actions [ngClass]="{ moveBtns: !open }">
    <button
      [matTooltip]="'Schedule Training'"
      matTooltipPosition="left"
      matTooltipClass="text-center"
      mat-mini-fab
      (click)="goToScheduleTraining()"
      class="action"
    >
      <mat-icon>
        <i class="icon far fa-calendar-alt"></i>
      </mat-icon>
    </button>
    <button
      [matTooltip]="'Help Center'"
      matTooltipPosition="left"
      matTooltipClass="text-center"
      mat-mini-fab
      (click)="goToHelp()"
      class="action"
    >
      <mat-icon>
        <i class="icon far fa-book"></i>
      </mat-icon>
    </button>
    <a
      [matTooltip]="'Email Support'"
      matTooltipPosition="left"
      matTooltipClass="text-center"
      mat-mini-fab
      href="mailto:support@tokeet.com"
      class="action mini-fab-link"
    >
      <mat-icon>
        <i class="icon far fa-envelope"></i>
      </mat-icon>
    </a>
    <button
      [matTooltip]="'Live Chat'"
      matTooltipPosition="left"
      matTooltipClass="text-center"
      mat-mini-fab
      (click)="openChat()"
      class="action"
    >
      <mat-icon>
        <i class="icon far fa-comments"></i>
      </mat-icon>
    </button>
    <button
      [matTooltip]="'Community'"
      matTooltipPosition="left"
      matTooltipClass="text-center"
      mat-mini-fab
      (click)="goToCommunity()"
      class="action"
    >
      <mat-icon>
        <i class="icon far fa-users"></i>
      </mat-icon>
    </button>
    <button
      [matTooltip]="'System Status'"
      matTooltipPosition="left"
      matTooltipClass="text-center"
      mat-mini-fab
      (click)="goToTokeetStatus()"
      class="action"
    >
      <mat-icon>
        <i class="icon far fa-server"></i>
      </mat-icon>
    </button>
  </eco-fab-speed-dial-actions>
</eco-fab-speed-dial>
